/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Actions_ImgInputs */

const es_admin_users_actions_img = /** @type {(inputs: Admin_Users_Actions_ImgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto de Perfil`)
};

const en_admin_users_actions_img = /** @type {(inputs: Admin_Users_Actions_ImgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile Image`)
};

/**
* | output |
* | --- |
* | "Profile Image" |
*
* @param {Admin_Users_Actions_ImgInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_users_actions_img = /** @type {((inputs?: Admin_Users_Actions_ImgInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Actions_ImgInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_users_actions_img(inputs)
	return en_admin_users_actions_img(inputs)
});
export { admin_users_actions_img as "admin.users.actions.img" }